import { Box, Flex, Text } from "@chakra-ui/react";
import type { MonthlyRewardCardProps } from "../MonthlyRewardCard";
import { getTitleName, getTitlePublisher, getTitleReadUrl, hasReleaseReadProgress, isTitleClaimed } from "../utils";
import { CoverArea } from "./CoverArea";
import { PriceRow } from "./PriceRow";
import { ClaimButton } from "./ClaimButton";
import { useSlideInMenu } from "../../../components/slideInMenu/hooks/useSlideInMenu";

// Figma: https://www.figma.com/design/z9Ut4lxLJQZK28vEZiHRwN/Monthly-rewards?node-id=122-3940

export function GridRewardCard({ titleData, isClaiming, isGold, onClaim, onSubscribe }: MonthlyRewardCardProps) {
  const displayTitle = getTitleName(titleData);
  const publisher = getTitlePublisher(titleData);
  const isClaimed = isTitleClaimed(titleData);
  const readUrl = getTitleReadUrl(titleData);
  const hasReadProgress = hasReleaseReadProgress(titleData);
  const { openReleaseInfoMenu, openBundleDetails } = useSlideInMenu();

  const handleOpenDetails = () => {
    const navigationContext = { area: "gold-rewards" };
    if (titleData.type === "bundle" && titleData.bundle?.uuid) {
      openBundleDetails(titleData.bundle.uuid, navigationContext);
      return;
    }
    if (titleData.type === "release" && titleData.release) {
      const release = titleData.release;
      if (!release.key) return;
      openReleaseInfoMenu(
        release.key,
        release.comic_slug ?? release.comic?.slug,
        navigationContext,
      );
    }
  };

  return (
    <Flex direction="column" gap="12px" minW={0}>
      <CoverArea titleData={titleData} onClick={handleOpenDetails} />
      <Box minH="48px">
        <Text
          fontFamily="Bricolage Grotesque"
          fontSize="16px"
          fontWeight={600}
          color="white"
          lineHeight="24px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {displayTitle}
        </Text>
        {publisher && (
          <Text
            fontFamily="Bricolage Grotesque"
            fontSize="14px"
            fontWeight={600}
            color="neutral.400"
            lineHeight="24px"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {publisher}
          </Text>
        )}
      </Box>
      <PriceRow retailPrice={titleData.retail_price} />
      <ClaimButton isGold={isGold} isClaimed={isClaimed} isClaiming={isClaiming} readUrl={readUrl} hasReadProgress={hasReadProgress} onClaim={onClaim} onSubscribe={onSubscribe} />
    </Flex>
  );
}
